import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const AssetModalFooter = /*#__PURE__*/ memo((param)=>{
    let { header, children, className } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("relative flex w-full flex-shrink-0 flex-col items-center justify-center overflow-hidden", className),
        children: [
            children,
            /*#__PURE__*/ _jsx("div", {
                className: "absolute bottom-0 left-0 flex h-16 w-full items-center justify-center border-t border-t-grey-5 bg-grey-1 px-4",
                children: header
            })
        ]
    });
});
AssetModalFooter.displayName = "AssetModalFooter";
